
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch/videos/[slug]",
      function () {
        return require("private-next-pages/watch/videos/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch/videos/[slug]"])
      });
    }
  